import { render, staticRenderFns } from "./SimilarityOptionsMenu.vue?vue&type=template&id=51729e92&scoped=true"
import script from "./SimilarityOptionsMenu.vue?vue&type=script&lang=js"
export * from "./SimilarityOptionsMenu.vue?vue&type=script&lang=js"
import style0 from "./SimilarityOptionsMenu.vue?vue&type=style&index=0&id=51729e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51729e92",
  null
  
)

export default component.exports